import { render, staticRenderFns } from "./PaypalButtons.vue?vue&type=template&id=b15f7526&"
import script from "./PaypalButtons.vue?vue&type=script&lang=js&"
export * from "./PaypalButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports